import { render, staticRenderFns } from "./SubmitView.vue?vue&type=template&id=0c2111f0&"
import script from "./SubmitView.vue?vue&type=script&lang=js&"
export * from "./SubmitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports